import React, { Suspense, useEffect, useRef, useState } from "react";
import Topbar from "src/components/topbar";
import Footer from "src/components/footer";
import { Outlet, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import actions from "src/store/auth/actions";
import ScrollToTop from "../ScrollToTop";
import ContactContainer from "../ContactContainer";
import UpdatesContainer from "../updatesContainer";
import Breadcrumb from "../Breadcrumb";
import CustomProgressBar from "../CustomProgressBar";
import AndroidSmartBanner from "src/components/androidSmartBanner";

const PageLayout = () => {
  const navbarRef = useRef(null);
  const darkMode = useSelector((state) => state.common.darkMode);
  const location = useLocation();
  const routeName = location?.pathname;
  const randomProgress = Math.floor(Math.random() * (70 - 54 + 1)) + 54;

  const currentProgressRef = useRef(randomProgress);

  useEffect(() => {
    const loadModule = async () => {
      await new Promise((resolve) => {
        const animateProgress = () => {
          const increment = Math.floor(Math.random() * 14) + 2;
          const newProgress = Math.min(
            100,
            currentProgressRef.current + increment
          );
          currentProgressRef.current = newProgress;

          if (newProgress < 100) {
            setTimeout(animateProgress, 200);
          } else {
            resolve();
          }
        };

        animateProgress();
      });
    };

    loadModule().then(() => {
      currentProgressRef.current = randomProgress;
    });
  }, [routeName]);

  return (
    <>
      <div className={"page-container" + (darkMode ? " dark-mode" : "")}>
        <AndroidSmartBanner />
        <Topbar navbarRef={navbarRef} />
        <Breadcrumb />
        <ScrollToTop />
        {/* <ContactContainer /> */}
        <main className="main-content d-flex flex-column">
          <UpdatesContainer />
          <Suspense
            fallback={
              <CustomProgressBar progress={currentProgressRef.current} />
            }
          >
            <Outlet />
          </Suspense>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default PageLayout;
